import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { WagmiProvider, useAccount, useSwitchChain } from 'wagmi';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createAppKit } from '@reown/appkit/react';
import { config, wagmiAdapter, projectId, networks } from './config';

import Home from './pages/Home';
import Swap from './pages/Swap';

const queryClient = new QueryClient();

// Buat Reown AppKit Modal (Tampilan persis seperti gambar)
createAppKit({
  adapters: [wagmiAdapter],
  networks,
  projectId,
  themeMode: 'light', // Force tema putih
  features: {
    email: false, // Menghilangkan opsi login email
    socials: false, // Menghilangkan opsi login sosmed
  },
  // URUTAN WALLET SESUAI PERMINTAAN
  featuredWalletIds: [
    '4622a2b2d6af1c9844944291e5e7351a6aa24cd7b23099efac1b2fd875da31a0', // 1. Trust Wallet
    '38f5d18bd8522c244bdd70cb4a68e0e718865155811c043f052fb9f1c51de662', // 2. Bitget Wallet
    'c57ca95b47569778a828d19178114f4db188b89b763c899ba0be274e97267d96', // 3. MetaMask
    // Opsi ke-4 WalletConnect QR akan otomatis mengikut di barisan ini
    '18388be9ac2d02726dbac9777c96efaac06d744b2f6d580fccdd4127a6d01fd1', // 5. Rabby Wallet
    '8a0ee50d1f22f6651afcae7eb4253e52a3310b90af5daef78a8c4929a9bb99d4'  // 6. Binance Web3 Wallet
  ]
});

const NetworkEnforcer = ({ children }) => {
  const { chain } = useAccount();
  const { switchChain } = useSwitchChain();

  useEffect(() => {
    if (chain && chain.id !== networks[0].id && switchChain) {
      switchChain({ chainId: networks[0].id });
    }
  }, [chain, switchChain]);

  return <>{children}</>;
};

function App() {
  return (
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>
        <NetworkEnforcer>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/swap" element={<Swap />} />
            </Routes>
          </BrowserRouter>
        </NetworkEnforcer>
      </QueryClientProvider>
    </WagmiProvider>
  );
}

export default App;